import React from 'react';
import Icons from '../img/sprite-custom.svg';

export default ({ name, color, classiAggiuntive, ...otherProps }) => (
  <svg role="img" aria-hidden={"true"} className={`icon ${classiAggiuntive ? classiAggiuntive : ''}`} style={{ fill: color }} {...otherProps}>
    <use xlinkHref={`${Icons}#${name}`} />
  </svg>
);
